/**
 * Detects social in-app browsers (Facebook, Instagram, WhatsApp, etc.).
 * These show "You're leaving our app" before opening external apps, so auto
 * Play Store fallback must be disabled or users get sent to install incorrectly.
 */
export function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.includes('fban') ||
    ua.includes('fbav') ||
    ua.includes('fb_iab') ||
    ua.includes('facebook') ||
    ua.includes('instagram') ||
    ua.includes('whatsapp') ||
    ua.includes('twitter') ||
    ua.includes('linkedinapp') ||
    ua.includes('tiktok') ||
    ua.includes('snapchat')
  );
}

export function inAppBrowserLabel(): string {
  if (typeof navigator === 'undefined') return 'this app';
  const ua = navigator.userAgent.toLowerCase();
  if (ua.includes('fban') || ua.includes('fbav') || ua.includes('facebook')) return 'Facebook';
  if (ua.includes('instagram')) return 'Instagram';
  if (ua.includes('whatsapp')) return 'WhatsApp';
  if (ua.includes('tiktok')) return 'TikTok';
  return 'this app';
}
